import CachePolicy from "http-cache-semantics";

export type HttpCacheRecordProps = {
  response: Response;
  policy: CachePolicy;
};

export class HttpCacheRecord {
  public static CACHE_POLICY_OPTIONS = {
    shared: false,
  };

  private props: HttpCacheRecordProps;

  get response() {
    return this.props.response;
  }
  get policy() {
    return this.props.policy;
  }

  constructor(props: HttpCacheRecordProps) {
    this.props = props;
  }

  static build(request: Request, response: Response): HttpCacheRecord {
    return new HttpCacheRecord({
      response,
      policy: new CachePolicy(
        {
          url: request.url,
          method: request.method,
          headers: Object.fromEntries(request.headers.entries()),
        },
        {
          status: response.status,
          headers: Object.fromEntries(response.headers.entries()),
        },
        HttpCacheRecord.CACHE_POLICY_OPTIONS,
      ),
    });
  }

  static fromObject(response: Response, policyObject: CachePolicy.CachePolicyObject) {
    return new HttpCacheRecord({
      response,
      policy: CachePolicy.fromObject(policyObject),
    });
  }

  storable(): boolean {
    return this.policy.storable();
  }

  satisfiesWithoutRevalidation(request: Request): boolean {
    return this.policy.satisfiesWithoutRevalidation({
      url: request.url,
      method: request.method,
      headers: Object.fromEntries(request.headers.entries()),
    });
  }
}
